/** @type {import('plop').PlopGeneratorConfig} */
module.exports = {
  description: 'Generate a new feature component with styles and a test',
  prompts: [
    {
      type: 'input',
      name: 'folderName',
      message: 'Folder name'
    },
    {
      type: 'input',
      name: 'componentName',
      message: 'Component name'
    },
  ],
  actions: () => {
    const rootTemplatePath = 'app/javascript/components/plop/templates/feature-component';
    const rootDestinationPath = 'app/javascript/components/{{snakeCase folderName}}';

    const actions = [
      {
        destination: rootDestinationPath,
        base: rootTemplatePath,
        templateFiles: [
          `${rootTemplatePath}/__tests__/*.hbs`,
          `${rootTemplatePath}/styles/*.hbs`,
          `${rootTemplatePath}/*.hbs`,
        ]
      }
    ];

    return actions.map(({ base, destination, templateFiles }) => ({
      type: 'addMany',
      destination,
      base,
      templateFiles
    }));
  },
};
